import React from 'react';

import { useDrawingArea } from '@mui/x-charts/hooks';

interface LinearGradientProps {
    id: string;
}

export function BlueLinearGradient(
    props: React.PropsWithChildren<LinearGradientProps>
) {
    const { top, height } = useDrawingArea();
    const svgHeight = top + height;
    return (
        <linearGradient
            id={props.id}
            x1="100%"
            x2="100%"
            y1={top}
            y2={svgHeight}
            gradientUnits="userSpaceOnUse" // Use the SVG coordinate instead of the component ones.
        >
            <stop offset="0" stopColor="#0F75FF" stopOpacity="0.3" />
            <stop offset="1" stopColor="#4B8EE2" stopOpacity="0.05" />
        </linearGradient>
    );
}

export function BrownLinearGradient(
    props: React.PropsWithChildren<LinearGradientProps>
) {
    const { top, height } = useDrawingArea();
    const svgHeight = top + height;
    return (
        <linearGradient
            id={props.id}
            x1="100%"
            x2="100%"
            y1={top}
            y2={svgHeight}
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" stopColor="#BA7B19" stopOpacity="0.3" />
            <stop offset="1" stopColor="#D4A574" stopOpacity="0.05" />
        </linearGradient>
    );
}
